import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {HashRouter} from 'react-router-dom'; // импорт BrowserRouter
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // импорт service worker registration
import { TENANT_APP_TITLE, TENANT_APP_TITLE_SHORT, TENANT_THEME_COLOR, TENANT_ID } from './config/tenant';

// Title and theme-color are now set by inline script in index.html (for iOS PWA support)
// JS fallback for any edge cases
if (document.title !== TENANT_APP_TITLE) document.title = TENANT_APP_TITLE;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <HashRouter > {/* Оборачиваем App в BrowserRouter */}
            <App />
        </HashRouter >
    </React.StrictMode>
);

// Service worker — только на реальных доменах (.local / .com / .app), НЕ на localhost
if (!(window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    serviceWorkerRegistration.register();
}

reportWebVitals();
